import { useSelector } from "react-redux";
import ProductPricingAPICall from "src/service/ProductPricingAPICall";

export function useProductPricingStore() {
    const pricingList = useSelector((state) => state.entities.model_ProductPricing.master_data_new)
    const bomPricingList = useSelector((state) => state.entities.model_ProductPricing.bom_master_data)
    let data = {
        pricingList,
        bomPricingList
    };

    let fetch = {
        fetch_product_pricing_list: async (params) => {
            return await new ProductPricingAPICall().getPricingNew(params)
        },
        get_pricing_by_id: (id)=>{
            return pricingList[id]? pricingList[id]:[];
        }
    };
    let set = {};

    return [data, fetch, set]
}